import styled from 'styled-components';

export const Painel = styled.section`
  display: flex;
  flex-wrap: wrap;
  gap: 16px 24px;
  align-items: flex-end;
  padding: 16px 40px;
  background: #fffef9;
  border-bottom: 1px solid #ddd;
  font-family: 'Public Sans', sans-serif;
`;

export const Campo = styled.label`
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #002e3b;
  min-width: 180px;
`;

export const GrupoDeCaixas = styled.fieldset`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 14px;
  border: none;
  margin: 0;
  padding: 0;

  legend {
    font-size: 13px;
    font-weight: 600;
    color: #002e3b;
    margin-bottom: 6px;
  }

  label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    color: #555;
    cursor: pointer;
  }
`;

export const Selecao = styled.select`
  padding: 8px 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 10px;
  background: white;
  color: #002e3b;
`;

export const CampoData = styled.input`
  padding: 7px 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 10px;
  color: #002e3b;
`;

export const Acoes = styled.div`
  display: flex;
  gap: 10px;
  margin-left: auto;
`;

const BotaoBase = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 15px;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const BotaoPrimario = styled(BotaoBase)`
  background: #6ab8a8;
  color: white;
`;

export const BotaoSecundario = styled(BotaoBase)`
  background: white;
  color: #002e3b;
  border: 1px solid #ccc;
`;

export const BotaoPdf = styled(BotaoBase)`
  background: #ff9f1f;
  color: white;
  padding: 6px 12px;

  .material-symbols-outlined {
    font-size: 20px;
  }
`;

export const Mensagem = styled.div`
  padding: 32px;
  text-align: center;
  color: #555;
  font-size: 15px;
`;
